import { START_X, START_Y } from './constants';
import type { Frog, Rect } from './state';
export const createFrog = (): Frog => ({ x: START_X, y: START_Y, previousX: START_X,
  previousY: START_Y, direction: 'up', hop: null, carrierId: null, furthestRow: 0, lady: false });
export const frogBox = (x: number, y: number): Rect => ({ x: x - 4, y: y - 4, w: 8, h: 9 });
